<template>
<div id="edit_info">
    <div id="main">
        <div id="password">
            <div id="header">
                <div class="header-wrap">
                    <div class="top-menu-bar">
                        <div class="back" @click="go_editinfo()">
                            <a href="#">
                                <img src="../../assets/images/back.png" alt="icon-menu">
                            </a>
                        </div>
                        <h1 class="page-title">
                            <a href="#">
                                <span>비밀번호 변경</span>
                            </a>
                        </h1>
                        <div class="mypage">
                            <a href="#">

                            </a>
                        </div>
                        <div class="bottom-radius"></div>
                    </div>
                </div>
            </div>
            <div class="edit-wrap">
                <div class="input-edit">
                    <div class="edit-title">비밀번호 변경</div>
                    <form id="edit_passoword" action="" method="">
                        <ul>
                            <li>
                                <label for="password_edit" class="hidden">변경 비밀번호</label>
                                <input type="password" v-model="password" name="edit_password" id="password_edit" placeholder="변경 비밀번호">
                            </li>
                            <li>
                                <label for="password_confirm" class="hidden">비밀번호 확인</label>
                                <input type="password" v-model="password_chk" name="confirm_password" id="password_confirm" placeholder="비밀번호 확인">
                            </li>
                        </ul>
                    </form>
                </div>
                <div class="btn-form-pass" @click="change_pass">
                    <div class="btn-ok"><span>확 인</span></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';
export default {
    name: 'edit_info',
    components: {},
    data() {
        return {
            password: '',
            password_chk: ''
        }
    },
    mounted() {
        this.$nextTick(function () {

        });

    },
    methods: {
         go_editinfo() {
            this.$router.push('/edit_info');
        },
        change_pass() {
            if (this.password != this.password_chk) {
                var data = {
                    code: 103,
                    message: '비밀번호가 서로 일치하지 않습니다.'
                };
                EventBus.$emit('popup-data', data);
                return;
            }
            if(this.password.length == 0 || this.password_chk.length == 0){
                var data = {
                    code: 103,
                    message: '비밀번호를 정확히 입력해주세요.'
                };
                EventBus.$emit('popup-data', data);
                return;
            }
            var user_info = this.$store.getters['getUser_info'];            

            var data = {
                password:this.password,
                m_user_id:user_info.value.m_user_id
            }
            var type = config.REQ_PASS_EDIT;
            common.getData(type, data,
                (response) => {
                    console.log(response);
                    if (response.result) {
                        //팝업
                        var data = {
                                code: 103,
                                message: '비밀번호가 변경되었습니다.'
                        };
                        EventBus.$emit('popup-data', data);
                        this.$router.push('/mypage');
                    }
                })


        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/EditPasswordPage.vue